/**
 * Spinner atom - replaces inline spinner divs across the app.
 */

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-[3px]',
  lg: 'h-12 w-12 border-4',
};

export default function Spinner({ size = 'md', className = 'border-primary' }: SpinnerProps) {
  return (
    <div className={`animate-spin rounded-full border-t-transparent ${sizeClasses[size]} ${className}`} />
  );
}
